import React, {Component} from 'react';
import {connect} from 'react-redux';

import DecorateContainer from '../../utils/DecoratedContainer';
import i18nLabels from './Header.18n';
import HeaderMainView from './Header.MainView';
import {UPDATE_SEARCH_QUERY} from '../../store/actions/ActionTypes';
import Utility from '../../utils/Helper';
import {
    getSearchResults,
    getTrendingKeywords,
    getSearchPromotions,
    getSuggestedSearches
} from '../../services/APIs/Solr';
import {getHeader} from '../../services/APIs/HeaderFooter';

const mapDispatchToProps = (dispatch) => {
    return {
        getHeader: () => dispatch(getHeader()),
        updateSearchString: (searchStr) => dispatch({type: UPDATE_SEARCH_QUERY, payload: searchStr}),
        getSearchResults: (searchString) => dispatch(getSearchResults(searchString)),
        getTrendingKeywords: () => dispatch(getTrendingKeywords()),
        getSearchPromotions: () => dispatch(getSearchPromotions()),
        getSuggestedSearches: (searchStr) => dispatch(getSuggestedSearches(searchStr))
    };
};

const mapStateToProps = (state) => {
    return {
        i18nLabels,
        searchString: Utility.getValues(state, 'searchInfo.searchQuery', ''),
        trendingSearches: Utility.getValues(state, 'searchInfo.trendingSearches', []),
        searchPromotions: Utility.getValues(state, 'searchInfo.searchPromotions', []),
        lastSearch: Utility.getValues(state, 'searchInfo.lastSearch', ''),
        selectedCategory: Utility.getValues(state, 'searchInfo.selectedCategory', ''),
        screenName: Utility.getValues(state, 'screenName.currentScreen', ''),
        headerDocument: Utility.getValues(state, 'headerFooter.headerDocument', '')
    };
};
class Header extends Component {
    render() {
        return <HeaderMainView {...this.props} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DecorateContainer(Header));
